import React, { useEffect, useReducer } from 'react';
import styles from './JackpotCasino.scss';
import cn from 'classnames';

// MANAGERS
import { TJackpotCasinoLevelItem } from '@GFTypes/index';
import { CurrencyUtils } from '@Core/Currencies/CurrencyUtils';
import timeFormat from '@Tools/TimeFormat';
import JackpotCasinoLevelItem from './JackpotCasinoLevelItem';

const JackpotCasinoStatusGroup: React.FC<{
    levelsData: Array<Array<TJackpotCasinoLevelItem>>;
    index: number;
    groupLabel: string;
    options?: { growthTrend: boolean };
}> = ({ levelsData, index, groupLabel, options = { growthTrend: false } }) => {
    useEffect(() => {});

    return (
        <>
            {levelsData[index] && (
                <div>
                    <div className={styles.jackpot_casino_states_header}>
                        {groupLabel}: <br />
                        Update time: {timeFormat(levelsData[index][0].timestamp).time}
                    </div>
                    <div>
                        <>
                            {levelsData[index] &&
                                levelsData[index].map((e: TJackpotCasinoLevelItem, i: number) => {
                                    return (
                                        <JackpotCasinoLevelItem
                                            data={e}
                                            key={i}
                                            growthTrend={
                                                options.growthTrend ? { show: true, value: levelsData[index - 1][i].currentValue } : { show: false, value: 0 }
                                            }
                                        />
                                    );
                                })}
                        </>
                    </div>
                </div>
            )}
        </>
    );
};

export default JackpotCasinoStatusGroup;
